import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export default function PEBreadcrumbs() {
    const location = useLocation();
    const vPathName = location.pathname;
    return (
        <div className="container-fluid p-0 breadcrumb">
            {vPathName === '/PriceEnquirySummary' ? (
                <div>
                    <span className="breadcrumb-arrow-inactive">Price Enquiry Summary{' '}</span>
                </div>
            ) : vPathName === '/PriceEnquiryDetail' ? (
                <div className="d-flex">
                    <Link
                        to="/PriceEnquirySummary"
                        state={location}
                        className={'breadcrumb-arrow-active mr-2'}>
                        Price Enquiry Summary
                    </Link>
                    <div>
                        <span className="breadcrumb-arrow-inactive">Price Enquiry Detail{' '}</span>
                    </div>
                </div>
            ) : (
                <></>
            )}
        </div>
    );
}
